import React, { Component } from "react";
import {
  Grid,
  Dropdown,
  Input,
  Checkbox,
  Icon,
  Popup,
  Modal,
  Button
} from "semantic-ui-react";
import { template } from "@babel/core";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { customFieldEdited } from "../../actions/customFields/editCustomFields";
import DropDownSettings from "./DropDownSettings";
import {
  createNotification,
  NOTIFICATION_TYPE_ERROR
} from "react-redux-notify";

class CustomField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cFieldlbl: this.props.customField.fieldName,
      cFieldtype: this.props.customField.fieldType,
      cFieldDisplay: this.props.customField.isFieldEnabled,
      cFieldRecRollover: this.props.customField.isRecurringAndRolloverEnabled,
      showCustomFieldlbllengthPopup: false
    };
    this.addTxtRef = React.createRef();
    this.switchCfieldNotification = {
      type: NOTIFICATION_TYPE_ERROR,
      duration: 5000,
      canDismiss: true
    };

    this.cFieldTypes = [
      {
        key: "text",
        value: "Text",
        text: "Text"
      },
      {
        key: "date",
        value: "Date",
        text: "Date"
      },
      {
        key: "singleSelect",
        value: "Single Select",
        text: "Single Select"
      }
    ];
  }

  onChangeInputHandler(event, data) {
    if (event.target.value.length > 80) {
      this.setState({ error: false, showCustomFieldlbllengthPopup: true });
    } else {
      this.setState({ error: false, showCustomFieldlbllengthPopup: false });
      let cFieldlbl = data.value;
      if (!this.props.isCfEdited) {
        this.props.customFieldEdited(!this.props.isCfEdited);
      }
      this.props.customField.isCustomfieldlabelEdited = true;
      this.props.customField.fieldName = cFieldlbl;
      this.setState({
        cFieldlbl: cFieldlbl
      });
    }
  }

  onChangeDropDownHandler(event, data) {
    let cFieldtype = data.value;
    if (
      this.props.customField.isFieldInUse &&
      (this.props.customField.fieldType === "Single Select" ||
        data.value === "Single Select")
    ) {
      const switchWarningNotification = {
        message: `Please note you can not change this field's type from/to Single Select Dropdown.`,
        ...this.switchCfieldNotification
      };
      this.props.createNotification(switchWarningNotification);
    } else {
      if (!this.props.isCfEdited) {
        this.props.customFieldEdited(!this.props.isCfEdited);
      }
      this.props.customField.isCustomfieldtypeEdited = true;
      this.props.customField.fieldType = cFieldtype;
      this.setState({
        cFieldtype: cFieldtype
      });
    }
  }

  onDisplayChkChanged(event, data) {
    let chkDisplayStatus = data.checked;
    if (!this.props.isCfEdited) {
      this.props.customFieldEdited(!this.props.isCfEdited);
    }

    this.props.customField.isFieldEnabled = chkDisplayStatus;
    this.setState({
      cFieldDisplay: chkDisplayStatus
    });
  }

  onRecRolloverChkChanged(event, data) {
    let chkRecRollStatus = data.checked;
    if (!this.props.isCfEdited) {
      this.props.customFieldEdited(!this.props.isCfEdited);
    }
    this.props.customField.isRecurringAndRolloverEnabled = chkRecRollStatus;
    this.setState({
      cFieldRecRollover: chkRecRollStatus
    });
  }
  handleCFieldlengthPopUpOpen = () => {
    if (this.addTxtRef.current.value.length > 80) {
      this.setState({ showCustomFieldlbllengthPopup: true });
    } else {
      this.setState({ showCustomFieldlbllengthPopup: false });
    }
  };

  handleCFieldlengthPopUpClose = () => {
    this.setState({ showCustomFieldlbllengthPopup: false });
  };

  render() {
    return (
      <Grid.Row columns={5} className={"py-4"}>
        <Grid.Column width={5}>
          <Popup
            on={this.props.customField.isCustomfieldlabelEdited ? "hover" : ""}
            trigger={
              <Input
                fluid
                placeholder=""
                maxLength={"81"}
                className={
                  this.props.customField.isCustomfieldlabelEdited &&
                    this.props.isCfEdited
                    ? "edited"
                    : ""
                }
                value={this.props.customField.fieldName}
                onChange={this.onChangeInputHandler.bind(this)}
                error={
                  this.props.customField.fieldName.trim() !== "" ? false : true
                }
              >
                <input ref={this.addTxtRef} />
              </Input>
            }
            content="Custom Field Name is restricted to 80 characters."
            inverted
            open={this.state.showCustomFieldlbllengthPopup}
            onOpen={this.handleCFieldlengthPopUpOpen.bind(this)}
            inverted
            onClose={this.handleCFieldlengthPopUpClose.bind(this)}
          ></Popup>
        </Grid.Column>
        <Grid.Column width={3}>
          <Dropdown
            fluid
            selection
            selectOnBlur={false}
            selectOnNavigation={false}
            options={this.cFieldTypes}
            value={this.props.customField.fieldType}
            //disabled={this.state.cFieldtype ==='Single Select' && this.props.customField.isFieldInUse && !this.props.customField.isCustomfieldtypeEdited?"disabled":""}
            className={
              this.props.customField.isCustomfieldtypeEdited &&
                this.props.isCfEdited
                ? "edited"
                : ""
            }
            onChange={this.onChangeDropDownHandler.bind(this)}
          />
        </Grid.Column>
        <Grid.Column width={2}>
          <Checkbox
            toggle
            checked={this.props.customField.isFieldEnabled}
            onChange={this.onDisplayChkChanged.bind(this)}
          />
        </Grid.Column>
        <Grid.Column width={2}>
          <Checkbox
            toggle
            checked={this.props.customField.isRecurringAndRolloverEnabled}
            onChange={this.onRecRolloverChkChanged.bind(this)}
          />
        </Grid.Column>
        <Grid.Column width={1}>
          {this.props.customField.fieldType === "Single Select" ? (
            <DropDownSettings
              customFieldId={this.props.customField.fieldID}
              customField={this.props.customField}
              options={this.props.customField.customFieldOptions}
            ></DropDownSettings>
          ) : (
              ""
            )}
        </Grid.Column>
      </Grid.Row>
    );
  }
}

function mapStatetoprops(state) {
  return {
    isCfEdited: state.customFieldsReducer.isCustomFieldEdited,
    createNotification: state.customFieldsReducer.createNotification
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      customFieldEdited,
      createNotification
    },
    dispatch
  );
}

export default connect(mapStatetoprops, mapDispatchToProps)(CustomField);
